<div class="buttons-container">
  <img (click)="openUrl('https://apps.apple.com/us/app/bruces/id1072320907')" class="logo margin-bottom_10"
    src="{{ appleLogo }}" alt="Apple Logo" />

  <img (click)="openUrl('https://play.google.com/store/apps/details?id=uk.co.brucesdoggydaycare.brucesdoggydaycare')"
    class="logo margin-bottom_30" src="{{ googleLogo }}" alt="Google Logo" />
</div>